<div class="container py-3">
  <div class="d-flex align-items-center justify-content-between mb-3">
    <h2 class="m-0">Workspace</h2>
    <div class="d-flex gap-2 align-items-end flex-nowrap">
      <input class="form-control form-control-sm" type="search" placeholder="Search..." [ngModel]="search()" (ngModelChange)="search.set($event)" style="min-width: 260px" />
    </div>
  </div>

  <div class="d-flex align-items-end justify-content-between mb-3">
    <ul class="nav nav-tabs m-0">
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab==='projects'" (click)="activeTab='projects'">Projects</button>
      </li>
      <li class="nav-item">
        <button class="nav-link" [class.active]="activeTab==='organizations'" (click)="activeTab='organizations'">Organizations</button>
      </li>
    </ul>
    <div class="d-flex gap-2">
      @if (activeTab==='projects') {
        <button class="btn btn-sm btn-outline-primary flex-shrink-0" [routerLink]="['/create-project']" [queryParams]="{ from: 'home' }" aria-label="Add Project" ngbTooltip="Add Project" placement="bottom">
          <i class="bi bi-plus-lg"></i>
        </button>
      }
      @if (activeTab==='organizations') {
        <button class="btn btn-sm btn-outline-primary flex-shrink-0" [routerLink]="['/create-organization']" [queryParams]="{ from: 'home' }" aria-label="Add Organization" ngbTooltip="Add Organization" placement="bottom">
          <i class="bi bi-plus-lg"></i>
        </button>
      }
    </div>
  </div>

  <div [hidden]="activeTab!=='projects'">
    <div class="card">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th style="width: 28%">Name</th>
                <th style="width: 20%">Description</th>
                <th style="width: 10%">Users</th>
                <th style="width: 12%">Build</th>
                <th style="width: 12%">Quality</th>
                <th style="width: 10%">Tickets</th>
                <th style="width: 8%"></th>
              </tr>
            </thead>
            <tbody>
              @for (p of filteredProjects(); track p) {
                <tr>
                  <td>
                    <div class="fw-semibold">{{ p.name }}</div>
                    <div class="small text-muted">Org: {{ getOrganizationNameForProject(p.id) || '—' }}</div>
                  </td>
                  <td>
                    <div class="text-truncate" style="max-width: 520px">{{ p.description || '—' }}</div>
                  </td>
                  <td>
                    <span class="badge bg-secondary">{{ getUserCountForProject(p.id) }}</span>
                  </td>
                  <td>
                    <span class="badge bg-success">Passing</span>
                  </td>
                  <td>
                    <span class="badge bg-success">Good</span>
                  </td>
                  <td>
                    <span class="badge bg-secondary">~{{ 5 + (p.name.length || 0) % 10 }}</span>
                  </td>
                  <td class="text-end">
                    <div class="d-inline-flex gap-2">
                      <button class="btn btn-sm btn-outline-secondary" (click)="editProject(p.id)" aria-label="Edit project" ngbTooltip="Edit project" placement="top">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="openDeleteProjectModal(p)" aria-label="Delete project" ngbTooltip="Delete project" placement="top">
                        <i class="bi bi-trash"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-secondary" (click)="setCurrentProject(p.id)" aria-label="Set as current project" ngbTooltip="Set as current project" placement="top">
                        <i class="bi bi-check-circle"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              }
              @if (filteredProjects().length === 0) {
                <tr>
                  <td colspan="7" class="text-center text-muted py-4">No projects found.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div [hidden]="activeTab!=='organizations'">
    <div class="card">
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="table-light">
              <tr>
                <th style="width: 26%">Name</th>
                <th style="width: 18%">Contact</th>
                <th style="width: 18%">Location</th>
                <th style="width: 8%">Users</th>
                <th style="width: 14%">Projects</th>
                <th style="width: 16%"></th>
              </tr>
            </thead>
            <tbody>
              @for (o of filteredOrganizations(); track o) {
                <tr>
                  <td>
                    <div class="fw-semibold">{{ o.name }}</div>
                  </td>
                  <td>
                    <div class="small">{{ o.email || '—' }}</div>
                  </td>
                  <td>
                    <div class="small">
                      {{ o.city || '—' }}, {{ o.state || '' }} {{ o.country || '' }}
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-secondary">{{ getUserCountForOrganization(o.id) }}</span>
                  </td>
                  <td>
                    <span class="badge bg-secondary">{{ getProjectCountForOrg(o.id) }} total</span>
                  </td>
                  <td class="text-end">
                    <div class="d-inline-flex gap-2">
                      <button class="btn btn-sm btn-outline-primary" [routerLink]="['/users']" aria-label="Manage users" ngbTooltip="Manage users" placement="top">
                        <i class="bi bi-people"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-secondary" (click)="editOrganization(o.id)" aria-label="Edit organization" ngbTooltip="Edit organization" placement="top">
                        <i class="bi bi-pencil"></i>
                      </button>
                      <button class="btn btn-sm btn-outline-danger" (click)="deleteOrganization(o.id)" aria-label="Delete organization" ngbTooltip="Delete organization" placement="top">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              }
              @if (filteredOrganizations().length === 0) {
                <tr>
                  <td colspan="6" class="text-center text-muted py-4">No organizations found.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #deleteProjectModal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Project</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDeleteProjectModal()" [disabled]="deletingProject"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">
      Are you sure you want to delete
      <span class="fw-semibold">{{ projectPendingDelete?.name }}</span>?
      This cannot be undone.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeDeleteProjectModal()" [disabled]="deletingProject">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDeleteProject()" [disabled]="deletingProject">
      @if (deletingProject) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ deletingProject ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</ng-template>

<ng-template #deleteOrganizationModal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Organization</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeDeleteOrganizationModal()" [disabled]="deletingOrganization"></button>
  </div>
  <div class="modal-body">
    <p class="mb-0">
      Are you sure you want to delete
      <span class="fw-semibold">{{ organizationPendingDelete?.name }}</span>?
      This cannot be undone.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="closeDeleteOrganizationModal()" [disabled]="deletingOrganization">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="confirmDeleteOrganization()" [disabled]="deletingOrganization">
      @if (deletingOrganization) {
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      }
      {{ deletingOrganization ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</ng-template>